import React from "react";

import {
  AccordionSectionHeader,
  AccordionSectionHeaderProps
} from "@packages/ds";

import { Button } from "ds/Button";

export interface TrackedAccordionSectionHeaderProps
  extends Omit<AccordionSectionHeaderProps, "onClear"> {
  /**
   * Optional callback for the Clear button
   */
  onClear?: () => void;

  /**
   * Analytics ID for tracking Clear button clicks (optional)
   */
  clearAnalyticId?: string;
}

/**
 * Accordion section header with analytics tracking for the clear button
 */
export const TrackedAccordionSectionHeader = ({
  onClear,
  clearAnalyticId = "clear",
  ...props
}: TrackedAccordionSectionHeaderProps) => {
  // If onClear is provided, we'll render the custom Button with analytics
  if (!onClear) {
    return <AccordionSectionHeader {...props} />;
  }

  // Use the Button from console app which has tracking
  const ClearButtonWithAnalytics = (
    <Button
      variant="link"
      analyticId={clearAnalyticId}
      onClick={() => onClear()}
      style={{ marginRight: "16px" }}
    >
      Clear
    </Button>
  );

  return (
    <AccordionSectionHeader
      {...props}
      // Pass null because we're handling our own clear button outside
      onClear={null}
    >
      {props.children}
      {ClearButtonWithAnalytics}
    </AccordionSectionHeader>
  );
};
